// @flow
'use strict';

import { connect } from 'react-redux';

import ListaCfe from './lista';

export default connect<*, *, *, *, *, *>()(ListaCfe);
